import React, { useContext, useState } from "react";
import { PageContext } from "./Pages.js";
import "../styles/DetailPage.scss";

const DetailPage = () => {
  const { setCurrentStep } = useContext(PageContext);

  return (
    <div className="detail-page-container">
      <img
        className="background-image"
        src="./images/detail_page_background.jpg"
        alt="background-image"
      />
      <div className="join-button-container">
        <img
          className="join-button"
          src="./images/join_button.png"
          onClick={() => setCurrentStep(2)}
          alt="start-2-button"
        />
      </div>
      <div className="start-form-coupons-button-container">
        <img
          className="start-form-button"
          src="./images/one_day_button.png"
          onClick={() => setCurrentStep(2)}
          alt="start-2-button"
        />
        <img
          className="start-coupons-button"
          src="./images/get_coupons_button.png"
          onClick={() => setCurrentStep(5)}
          alt="start-2-button"
        />
      </div>
      <div className="back-button-container">
        <img
          className="back-button"
          src="./images/back_to_home_page_button.png"
          onClick={() => setCurrentStep(0)}
          alt="start-2-button"
        />
      </div>
    </div>
  );
};

export default DetailPage;
